<div class="mainComponent">
    <!-- <div class="mainComponent" *ngIf="raceIsLoaded" [ngStyle]="{'background-image': 'url('+ pictureLink +')', 'background-position': 'fixed'}"> -->
    @if (isLoading$ | async) {
    <aoe-loading-spinner>
        <p class="small">Chargement de la course</p>
    </aoe-loading-spinner>
    } @else {
    @if (race) {
    @if (raceName) {
    <aoe-header [title]="raceName" [subTitle]="raceLocation.start" [backgroundImage]="pictureLink"></aoe-header>
    }
    <div class="content">
        @if(raceStartTime) {
        <div class="raceStatus d-flex flex-column justify-content-center align-items-center">
            <h2>{{raceStatus}} @if(isInProgress) {- {{timeFromStart$ | async}} } </h2>
            <h6 class="start-time">Heure départ: {{raceStartTime | date: "EE d LLL HH:mm:ss":undefined:'fr-FR'
                }}
            </h6>
        </div>
        }

        @if (displayDetails) {
        <div class="bgGray">

            <div class="container d-flex flex-md-row flex-column">
                <div class="col-lg-4 col-md-6 mb-3">
                    <aoe-race-details [race]="race" [video]="video"></aoe-race-details>
                </div>
                @if (polyline && raceName && raceElevation && raceDistance) {
                <div style="width: 100%;">
                    <aoe-map [polyline]="polyline" [raceName]="raceName" [raceDistance]="raceDistance"
                        [raceElevation]="raceElevation" [markers]="markers" [color]="raceColor"
                        [pointer]="hoverDataCoordinate" class="col-lg-8 col-md-6 col-12 mt-5 mt-lg-0">
                    </aoe-map>
                </div>
                }


            </div>

        </div>
        }


        <div class="container d-flex flex-column">
            <div #profilDiv class="d-flex flex-column justify-content-center w-100">
                @if (raceProfilWidth > 0) {
                <aoe-race-profil [data]="raceProfilData" [profilOption]="profilOptions" [raceLocation]="raceLocation"
                    [checkpoints]="points" (coordinatesHovering)="hoverDataCoordinate = $event">
                </aoe-race-profil>
                }

            </div>

            @if (partnerId) {<aoe-partners [pictureId]="partnerId"></aoe-partners>}
            @if (raceStatusCode && event) {
            <aoe-ranking [race]="race" [points]="points" [eventId]="event.id"></aoe-ranking>
            } @else {
            <p class="small text-center mt-3">Le classement est actuellement indisponible</p>

            }
        </div>


    </div>
    } @else {
    <p>La course n'existe pas</p>
    }
    }

</div>